import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { GoSearch } from "react-icons/go";
import { axiosInstance } from "../../axiosInstance";
import { Link, useNavigate } from "react-router-dom";

const columns = [
  { id: "vehicle_type", label: "VEHICLE TYPE", minWidth: 170, align: "center" },
  {
    id: "ryder_charges",
    label: "RYDER CHARGES",
    minWidth: 170,
    align: "center",
  },
  {
    id: "gomak_commision",
    label: "GOMAK COMMISSION",
    minWidth: 100,
    align: "center",
  },
  { id: "ryder_gst", label: "RYDER GST", minWidth: 170, align: "center" },
  { id: "gomak_gst", label: "GOMAK GST", minWidth: 170, align: "center" },
  { id: "actions", label: "ACTIONS", minWidth: 100, align: "center" },
];

function createData(
  vehicle_type,
  ryder_charges,
  gomak_commision,
  ryder_gst,
  gomak_gst
) {
  return { vehicle_type, ryder_charges, gomak_commision, ryder_gst, gomak_gst };
}

const rows = [
  createData("2 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
  createData("3 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
  createData("2 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
  createData("3 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
  createData("2 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
  createData("3 Wheeler", "₹ 40.00", "₹ 5.00", "5%", "5%"),
];

export function Pricing() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [pricingList, setPricingList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const fetchPricings = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get("/admin/pricemaster/");
      console.log("✅ Pricings list response:", res.data);
      if (res.data.status === "success") {
        setPricingList(res.data.data || []);
      } else {
        setError("Failed to fetch Pricings data.");
      }
    } catch (err) {
      console.error("❌ Error fetching Pricings data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPricings();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const formatValue = (columnId, value) => {
    if (value === null || value === undefined || value === "") return "--";

    switch (columnId) {
      case "vehicle_type":
        return value
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase());

      case "ryder_charges":
      case "gomak_commision":
        return `₹ ${Number(value).toFixed(2)}`;

      case "ryder_gst":
      case "gomak_gst":
        return `${value}%`;

      default:
        return value;
    }
  };

  return (
    <div>
      <div className="admin-top-container">
        <div className="admin-listText">Pricings</div>
        <div>
          {/* <select className="listAdmin-showRecords">
            <option>Show No of Records</option>
            <option>10</option>
            <option>25</option>
            <option>50</option>
            <option>100</option>
          </select> */}
        </div>
        <div className="search-container">
          {/* <div className="nav-search ">
            <span className="search-icons">
              <GoSearch />
            </span>
            <input type="text" placeholder="Search"></input>
          </div> */}
        </div>
        {/* <div className="btnAdd">
          <button onClick={() => navigate("/add-pricing")}>
            + Add Pricing
          </button>
        </div> */}
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer sx={{ maxHeight: 440 }} className="Table-container">
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                    className="table-header"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    <CircularProgress />
                  </TableCell>
                </TableRow>
              ) : pricingList.length > 0 ? (
                pricingList
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      className="table-row"
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 1 ? "#E7F0F9" : "white",
                      }}
                    >
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            key={column.id}
                            align={column.align}
                            className={`${column.id}-column tableCelldata`}
                            sx={{
                              color:
                                column.id === "status"
                                  ? value === "Active"
                                    ? "green"
                                    : "red"
                                  : "inherit",
                            }}
                          >
                            {column.id === "actions" ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  gap: "8px",
                                }}
                              >
                                <IconButton sx={{ color: "black" }}>
                                  <EditIcon
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "18px",
                                    }}
                                    onClick={() =>
                                      navigate(`/edit-pricing/${row.id}`)
                                    }
                                  />
                                </IconButton>
                              </div>
                            ) : value === null ||
                              value === undefined ||
                              value === "" ? (
                              "--"
                            ) : (
                              formatValue(column.id, row[column.id])
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={columns.length}
                    align="center"
                    style={{ padding: "40px 0" }}
                  >
                    No Data Available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={pricingList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </div>
  );
}
